// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZXFp4","buttons":"styles_buttons__26O-f"};